import { existHierarchy, alert, notification } from '../plugins/helpers'
import { confirmationMessage } from '../plugins/constants'
import { mapState } from 'vuex'
import { AlertTypes } from '../plugins/alerts_types'
export default {
  data: () => ({
    dialogCommercialHierarchyVisible: false,
    dialogAssistentCommercialHierarchyVisible: false,
    commercialHierarchyData: {},
    commercialHierarchyAssistentData: {}
  }),
  computed: {
    ...mapState(['hierarquia_comercial']),
    is_usuario_logado_hierarquia () {
      return existHierarchy(this.hierarquia_comercial)
    }
  },
  methods: {
    validateHierarchyReturn (result) {
      if (this.verifyIfLoginIsCommercialHierarchy(result)) {
        const rc = (result.data.hierarquia_comercial && result.data.hierarquia_comercial.listaGerenteNegocio)

        if (this.verifyIfLoginIsCommercialHierarchyAssistent(result.data.hierarquia_comercial)) {
          this.$session.set('nome', result.data.hierarquia_comercial.nome_assistente)
          if (this.verifyIfLoginIsCommercialHierarchyAssistentMultiple(result)) {
            this.dialogAssistentCommercialHierarchyVisible = true
            this.commercialHierarchyAssistentData = result.data.hierarquia_comercial
            return true
          }
        }

        if (rc) {
          this.commercialHierarchyData = result.data.hierarquia_comercial
          this.dialogCommercialHierarchyVisible = true
        }
        return true
      } else {
        return false
      }
    },
    verifyIfLoginIsCommercialHierarchyAssistentMultiple (result) {
      return (this.verifyIfLoginIsCommercialHierarchy(result) &&
        this.verifyIfLoginIsCommercialHierarchyAssistent(result.data.hierarquia_comercial) &&
        result.data.hierarquia_comercial.hierarquia_assistente &&
        result.data.hierarquia_comercial.hierarquia_assistente.length > 1)
    },
    verifyIfLoginIsCommercialHierarchyAssistent (result) {
      return result && result.codigo_assistente
    },
    verifyIfLoginIsCommercialHierarchy (result) {
      return existHierarchy(result.data.hierarquia_comercial)
    },
    verificarIntegridadeHierarquia (hierarquia) {
      // Verifica se a hierarquia existe e ambos os identificadores estão ausentes
      if (existHierarchy(hierarquia) &&
          !(hierarquia?.gerenteNegocioSelecionado?.codigoUsuario ||
            hierarquia?.gerenteNegocioSelecionado?.idEstruturaComercial)) {
        return this.$router.replace({ name: 'logout' })
      }

      return true
    },
    resetarEstruturaComercial () {
      if (!this.hierarquia_comercial.gerenteNegocioSelecionado.unicaEstruturaComercial) {
        this.hierarquia_comercial.estruturaComercialSelecionada = null
      }
      this.resetarPontoDeVenda()
    },
    resetarPontoDeVenda () {
      this.$session.set('id_ponto_venda', '')
      this.$session.set('cd_ponto_venda', '')
      this.$session.set('nm_ponto_venda', '')
      this.$session.set('comissionados', [])
      this.$session.set('id_comissionado_venda', '')
    },
    async setarSessaoVendedorParaUsuarioGNRC (flavor, id_empresa, id_comissionado_venda, id_ponto_venda, id_unidade_negocio) {
      try {
        const estruturaSelecionadaComPv = await this.buscarEstruturaSelecionadaComPv(id_ponto_venda)
        const unidadeCompleta = await this.buscarUnidadeNegocio(id_empresa, id_unidade_negocio)
        const dadosPv = estruturaSelecionadaComPv.dadosPv
        this.setarEstruturaGNRC(estruturaSelecionadaComPv.dadosEstrutura)
        this.setarPontoDeVendaGNRC(dadosPv.idPontoVenda, dadosPv.codigoPontoVenda, dadosPv.nomePontoVenda, dadosPv.comissionados)
        this.setarComissionadoGNRC(id_comissionado_venda)
        this.$session.set('id_empresa', id_empresa)
        this.$session.set('flavor', flavor)
        this.$session.set('id_unidade_negocio', id_unidade_negocio)
        this.$session.set('unidades', [unidadeCompleta])
        this.$session.set('sinalMudarIdentidadeVisual', true)
      } catch (err) {
        throw err
      }
    },
    setarComissionadoGNRC (id_comissionado_venda) {
      this.$session.set('id_comissionado_venda', id_comissionado_venda)
    },
    setarPontoDeVendaGNRC (id_ponto_venda, cd_ponto_venda, nm_ponto_venda, comissionados) {
      this.$session.set('id_ponto_venda', id_ponto_venda)
      this.$session.set('cd_ponto_venda', cd_ponto_venda)
      this.$session.set('nm_ponto_venda', nm_ponto_venda)
      this.$session.set('comissionados', comissionados)
    },
    setarEstruturaGNRC ({ codigoEstruturaComercialCompleta, idEstruturaComercial, nomeEstruturaComercial, nomeExibicaoEstrutura }) {
      this.$session.set('hierarquia_comercial', {
        ...this.hierarquia_comercial,
        estruturaComercialSelecionada: {
          codigoEstruturaComercialCompleta,
          idEstruturaComercial,
          nomeEstruturaComercial,
          nomeExibicaoEstrutura
        }
      })
    },
    async buscarEstruturaSelecionadaComPv (id_ponto_venda) {
      let gnSelecionado = this.hierarquia_comercial.gerenteNegocioSelecionado?.codigoUsuario || ''
      let hierarquiaSelecionada = this.hierarquia_comercial.estruturaComercialSelecionada?.idEstruturaComercial || ''
      let path = ''
      if (!gnSelecionado && !hierarquiaSelecionada) {
        throw new Error('Nenhum identificador válido encontrado para buscar a estrutura.')
      }
      if (gnSelecionado !== '') {
        path = `estrutura_por_ponto_venda/${gnSelecionado}/${id_ponto_venda}`
      } else {
        path = `estrutura_por_id_estrutura/${hierarquiaSelecionada}/${id_ponto_venda}`
      }
      return this.$http.get(path).then((response) => {
        return response.data
      })
    },
    async buscarUnidadeNegocio (id_empresa, id_unidade_negocio) {
      return this.$http.get(`/comissionado/unidade_negocio/${id_empresa}/${id_unidade_negocio}`).then((response) => {
        return response.data.unidade
      })
    },
    validarPontosDeVenda () {
      const pontosVenda = this.pontosVenda || []

      if (pontosVenda.length === 1 && pontosVenda[0].idPontoVenda === 'todos') {
        notification(AlertTypes.ERROR, 'Caro parceiro, no momento não existe ponto de venda atrelado à Estrutura Comercial selecionada. Caso isso for um erro, por favor, entre em contato com a Área de Suporte!')
        return false
      }

      return true
    },
    isUsuarioFluxoVendas (usuarioLogado, selectConfirm, isUsuarioTrocandoFluxo) {
      if (!usuarioLogado || isUsuarioTrocandoFluxo) {
        selectConfirm()
        return
      }

      const currentPath = this.$route.path
      const fluxoVendasPaths = ['/cadastro', '/iniciar-venda', '/politica-vendas', '/politica-vendas/selecionar-bem', '/minhas-vendas/detalhes-venda', '/minhas-vendas/detalhes-venda/contrato-venda']
      if (fluxoVendasPaths.includes(currentPath)) {
        alert({
          text: confirmationMessage,
          buttons: {
            'Fechar': () => true,
            'Confirmar': () => {
              selectConfirm()
            }
          }
        })
      } else {
        selectConfirm()
      }
    }
  }
}
